import type { ActionProperties, PackageReferenceProperties } from "@octopusdeploy/octopus-server-client";
import { isEqual } from "lodash";
import type { ActionEditProps } from "~/components/Actions/pluginRegistry";

export function ValueInPropertiesOrErrorsHasChanged<P = PackageReferenceProperties>(keysObject: Record<string, string>, newProps: ActionEditProps<ActionProperties, P>, props: ActionEditProps<ActionProperties, P>) {
    return !isEqual(newProps.errors, props.errors) || Object.keys(keysObject).some((p) => newProps.properties[p] !== props.properties[p]);
}
